import React from 'react';
import { Shield, Key, CheckCircle, AlertTriangle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Alert, AlertDescription } from '@/components/ui/alert';

export const CognisegTab = ({ settings, handleChange }) => (
  <Card className="bg-white border-slate-200">
    <CardHeader>
      <CardTitle className="text-slate-900 flex items-center gap-2">
        <Shield className="w-5 h-5 text-indigo-700" />
        Gestor de Triagem CogniSeg
      </CardTitle>
      <CardDescription className="text-slate-500">
        Identidade e password globais do utilizador Gestor de Triagem criado automaticamente
        em cada tenant provisionado no modo <strong>CogniSeg</strong> (serviço prestado pela CogniSeg).
        Este utilizador recebe todas as notificações do fluxo em cada plataforma cliente.
      </CardDescription>
    </CardHeader>
    <CardContent className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-slate-600">Email global</Label>
          <Input
            type="email"
            value={settings.cogniseg_triage_email || ''}
            onChange={(e) => handleChange('cogniseg_triage_email', e.target.value)}
            placeholder="gestortriagem@cogniseg.com"
            className="bg-white border-slate-300 text-slate-900"
            data-testid="cogniseg-triage-email-input"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-slate-600">Nome global</Label>
          <Input
            value={settings.cogniseg_triage_name || ''}
            onChange={(e) => handleChange('cogniseg_triage_name', e.target.value)}
            placeholder="Gestor de Triagem"
            className="bg-white border-slate-300 text-slate-900"
            data-testid="cogniseg-triage-name-input"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label className="text-slate-600 flex items-center gap-2">
          <Key className="w-4 h-4" />
          Password global do Gestor de Triagem CogniSeg
        </Label>
        <Input
          type="password"
          value={settings.cogniseg_triage_password || ''}
          onChange={(e) => handleChange('cogniseg_triage_password', e.target.value)}
          placeholder={settings.has_cogniseg_password ? '•••••••••• (definida) — insira nova para alterar' : 'Definir password (mín. 8 caracteres)'}
          className="bg-white border-slate-300 text-slate-900"
          data-testid="cogniseg-triage-password-input"
        />
        <p className="text-xs text-slate-500">
          {settings.has_cogniseg_password
            ? 'A password está configurada. Alterá-la propaga automaticamente para todos os utilizadores CogniSeg existentes.'
            : 'Ainda não configurada. É obrigatória para criar tenants em modo CogniSeg.'}
        </p>
      </div>

      <Alert className={settings.has_cogniseg_password ? 'bg-green-50 border-green-200' : 'bg-amber-50 border-amber-200'}>
        {settings.has_cogniseg_password
          ? <CheckCircle className="w-4 h-4 text-green-600" />
          : <AlertTriangle className="w-4 h-4 text-amber-600" />}
        <AlertDescription className={settings.has_cogniseg_password ? 'text-green-800' : 'text-amber-800'}>
          {settings.has_cogniseg_password
            ? 'Configuração completa — pode criar tenants em modo CogniSeg.'
            : 'Configure a password global antes de tentar criar tenants em modo CogniSeg.'}
        </AlertDescription>
      </Alert>
    </CardContent>
  </Card>
);
